import { createContext } from "react";

const ConnectedWalletContext = createContext({
  connectedAddress: null,
  setConnectedAddress: () => {},
});

export default ConnectedWalletContext;
